'use strict';
import React from 'react';
import * as ReactRedux from 'react-redux';

if (typeof window !== 'undefined') {
    var $ = window.$;
}
import panelActions from '../../redux/panelAction';
import policyActions from '../../redux/policyActions';
import marketplaceActions from '../../redux/marketplaceActions';
import CommonModule from '../../../src/public/js/common.js';
import { Container } from '@mui/material';

class FooterLayoutComponent extends React.Component {
    componentDidMount() {
        if ((this.props.panels == null || this.props.panels.length == 0) && this.props.loadPanels != null) {
            this.props.loadPanels();
        }

        if (typeof this.props.loadMarketplaceInfo === 'function') {
            this.props.loadMarketplaceInfo();
        }
    }

    acceptCookie() {
        CommonModule.createCookie('acceptCookiePolicy', 1, 1);
        $('.cookie-bar').fadeOut(1000, function() {
            $('.cookie-bar').remove();
        });
    }

    renderCookie() {
        if (this.props.marketplaceControlFlags) {
            let showCookiePolicy = this.props.marketplaceControlFlags.CookiesPolicy || false;
            if (showCookiePolicy) {
                let learnMoreTitle = '';
                let cookieTitle =
                    'This website uses cookies to help us improve your browsing experience and provide personalized communications.';
                let learnMoreUrl = '#';
                let acceptButtonTitle = '';

                if (this.props.cookieData) {
                    CommonModule.changeFavicon(this.props.favIconData);
                    this.props.cookieData.forEach(function(cf) {
                        if (cf.Name.toLowerCase() === 'message' && cf.Values) {
                            cookieTitle = cf.Values[0];
                        }
                        if (cf.Name.toLowerCase() === 'accept button' && cf.Values) {
                            acceptButtonTitle = cf.Values[0];
                        }
                        if (cf.Name.toLowerCase() === 'cookie policy link button' && cf.Values) {
                            learnMoreTitle = cf.Values[0];
                        }
                        if (cf.Name.toLowerCase() === 'button url' && cf.Values) {
                            learnMoreUrl = cf.Values[0];
                            if (!learnMoreUrl.startsWith('http://') && !learnMoreUrl.startsWith('https://')) {
                                learnMoreUrl = 'https://' + learnMoreUrl;
                            }
                        }
                    });

                    if (CommonModule.getCookie('acceptCookiePolicy') === 1) {
                        return '';
                    }
                } else {
                    return '';
                }
                if (typeof window !== 'undefined') {
                    return (
                        <div className='cookie-bar'>
                            <div className='flex-cookier-bar'>
                                <p>
                                    {cookieTitle}&nbsp;
                                    <a href={learnMoreUrl} target='_blank'>
                                        {learnMoreTitle}
                                    </a>
                                </p>
                                <a className='cookie-btn' href='#' onClick={e => this.acceptCookie(e)}>
                                    {acceptButtonTitle}
                                </a>
                            </div>
                        </div>
                    );
                }
                return '';
            }
        }
    }

    renderSocialMediaLinks() {
        return (
            <div className='tw-flex tw-gap-[10px] tw-items-center tw-self-start tw-pl-[15px]'>
                <a href='https://www.facebook.com/BCAA' target='_blank' rel='noopener noreferrer'>
                    <img
                        src='https://www.bcaa.com/-/media/bcaa/images/logos/facebook.svg?h=21&iar=0&w=9&hash=B0DF214CD19BBEC85D7E94560602D2FC'
                        alt='Facebook'
                        className='hover:tw-brightness-125 hover:tw-scale-110 hover:tw-transition-all hover:tw-duration-200 hover:tw-ease-in-out'
                    />
                </a>
                <a href='https://www.twitter.com/bcaa' target='_blank' rel='noopener noreferrer'>
                    <img
                        src='https://marketplace.bcaa.com/assets/images/x-logo.svg?h=5&iar=0&w=8'
                        alt='Twitter'
                        className='tw-w-[16px] tw-h-auto hover:tw-brightness-125 hover:tw-scale-110 hover:tw-transition-all hover:tw-duration-200 hover:tw-ease-in-out'
                    />
                </a>
                <a href='https://www.youtube.com/user/bcaavideos' target='_blank' rel='noopener noreferrer'>
                    <img
                        src='https://www.bcaa.com/-/media/bcaa/images/logos/youtube.svg?h=16&iar=0&w=23&hash=3E3A643571801C4849C4B8301BFCFA18'
                        alt='YouTube'
                        className='hover:tw-brightness-125 hover:tw-scale-110 hover:tw-transition-all hover:tw-duration-200 hover:tw-ease-in-out'
                    />
                </a>
                <a href='https://www.instagram.com/bcaarewards' target='_blank' rel='noopener noreferrer'>
                    <img
                        src='https://www.bcaa.com/-/media/bcaa/images/logos/instagram.svg?h=20&iar=0&w=20&hash=DA5713C8CAF92C11E0C23C15D7909454'
                        alt='Instagram'
                        className='hover:tw-brightness-125 hover:tw-scale-110 hover:tw-transition-all hover:tw-duration-200 hover:tw-ease-in-out'
                    />
                </a>
            </div>
        );
    }

    render() {
        return (
            <Container maxWidth='xl' className='lg:tw-px-[40px] xl:tw-px-[100px]'>
                <div className='tw-w-full tw-bg-[#0050c4] tw-font-sans tw-text-white tw-py-[20px]'>
                    <div className='tw-flex tw-flex-col tw-w-full'>
                        <footer className='tw-w-full tw-bg-[#0050c4] tw-text-white'>
                            <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between tw-gap-[10px] md:tw-gap-0'>
                                {/* First column */}
                                <div className='tw-flex-1 tw-pb-[14px] md:tw-mb-0 tw-border-b tw-border-[#cddffa] md:tw-border-0'>
                                    <h3 className='tw-text-[18px] tw-leading-[1.1] tw-font-bold tw-text-white tw-mb-[10px] tw-tracking-wide tw-font-bcaasans-regular'>
                                        BCAA TASK MARKETPLACE
                                    </h3>
                                    <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-gap-6 tw-space-y-2 md:tw-space-y-0 tw-text-[14px] tw-uppercase tw-font-bcaasans-regular tw-text-white'>
                                        <ul className='tw-space-y-2'>
                                            <li>
                                                <a
                                                    href='/search'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Find a tasker
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='/pages/provide-a-task?serviceableArea=Test+Address%2C+Canada%2C+BC%2C+Vancouver%2C+V5M+1Y4'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Provide a task
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='/pages/about'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    About
                                                </a>
                                            </li>
                                        </ul>
                                        <ul className='tw-space-y-2'>
                                            <li>
                                                <a
                                                    href='https://www.bcaa.com/bcaa-marketplace/task-marketplace/contact-us'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Contact Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='https://bcaa.com/tm-faq'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    FAQ
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* Second column */}
                                <div className='tw-flex-1 tw-pb-[14px] md:tw-mb-0 tw-border-b tw-border-[#cddffa] md:tw-border-0'>
                                    <h3 className='tw-text-[18px] tw-leading-[1.1] tw-font-bold tw-text-white tw-mb-[10px] tw-tracking-wide tw-font-bcaasans-regular'>
                                        BCAA
                                    </h3>
                                    <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-gap-6 tw-space-y-2 md:tw-space-y-0 tw-text-[14px] tw-uppercase tw-font-bcaasans-regular tw-text-white'>
                                        <ul className='tw-space-y-2'>
                                            <li>
                                                <a
                                                    href='https://www.bcaa.com/membership'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Membership
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='https://www.bcaa.com/insurance'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Insurance
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='https://www.bcaa.com/automotive'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Automotive
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='https://www.bcaa.com/community'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    Impact
                                                </a>
                                            </li>
                                        </ul>
                                        <ul className='tw-space-y-2'>
                                            <li>
                                                <a
                                                    href='https://marketplace.bcaa.com'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    BCAA Auto Marketplace
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href='https://connect.bcaa.com'
                                                    target='_blank'
                                                    className='hover:tw-text-white hover:tw-font-semibold tw-transition-colors'
                                                >
                                                    BCAA Connect
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* Social column */}
                                <div className='tw-flex-1 tw-flex tw-flex-wrap tw-justify-end tw-gap-[10px]'>
                                    <h3 className='tw-text-[16px] tw-font-bold tw-text-white tw-leading-normal tw-font-bcaasans-regular'>
                                        Follow BCAA
                                    </h3>
                                    {this.renderSocialMediaLinks()}
                                </div>
                            </div>
                            <hr className='tw-my-[10px] tw-border-[#cddffa] md:tw-my-8' />
                            <div className='tw-flex tw-flex-row tw-gap-[10px] tw-flex-wrap tw-justify-between tw-items-stretch md:tw-flex-nowrap md:tw-items-normal'>
                                <header
                                    className='tw-flex md:tw-mr-auto tw-flex-col tw-gap-0 md:tw-justify-between lg:tw-gap-[10px]'
                                    role='banner'
                                >
                                    <a href='https://www.bcaa.com' target='_blank' rel='noopener noreferrer'>
                                        <img
                                            src='https://www.bcaa.com/-/media/bcaa/images/logos/bcaa_primary_hex_rev.svg?iar=0&hash=8D41370F9D8DA43825AA96DA4CC0D6FC'
                                            alt='BCAA-CAA Primary Logo Rev'
                                            className='tw-h-10'
                                        />
                                    </a>
                                    <p>
                                        <a
                                            href='https://www.bcaa.com'
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='tw-text-[.75rem] lg:tw-text-[14px] tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                        >
                                            Visit BCAA.com
                                        </a>
                                    </p>
                                </header>
                                <div className='tw-max-w-[540px] tw-order-2 md:tw-order-1'>
                                    <div className='tw-text-[7.5px] tw-font-bcaasans-regular tw-text-white tw-space-y-2 md:tw-text-right'>
                                        <p>
                                            BCAA respectfully acknowledges that we operate and support Members and
                                            customers on the ancestral, unceded territories of Indigenous communities
                                            across what is known today as BC. BCAA is headquartered on the lands of the
                                            hən̓q̓əmin̓əm̓ and Sḵwx̱wú7mesh speaking peoples, known today as the City of
                                            Burnaby.
                                        </p>
                                        <p>
                                            Insurance is sold through B.C.A.A. Holdings Ltd. dba BCAA Insurance Agency,
                                            a licensed insurance agent, and underwritten by various underwriters. Visit{' '}
                                            <a
                                                href='https://bcaa.com/underwriters'
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className='tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                            >
                                                bcaa.com/underwriters.
                                            </a>
                                        </p>
                                        <p>
                                            BCAA (The British Columbia Automobile Association) is a member of the{' '}
                                            <a
                                                href='https://www.caa.ca'
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className='tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                            >
                                                Canadian Automobile Association
                                            </a>{' '}
                                            (CAA) and the{' '}
                                            <a
                                                href='https://www.aaa.com'
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                className='tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                            >
                                                American Automobile Association
                                            </a>{' '}
                                            (AAA), serving Members in British Columbia and the Yukon.{' '}
                                            <strong>Call 1-888-268-2222</strong>
                                        </p>
                                        <p>
                                            <strong>
                                                <a
                                                    href='https://www.bcaa.com/legal/terms-conditions'
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    className='tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                                >
                                                    Terms
                                                </a>{' '}
                                                |{' '}
                                                <a
                                                    href='https://www.bcaa.com/legal/privacy-policy'
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    className='tw-text-white tw-underline tw-font-bold hover:tw-text-white hover:tw-underline'
                                                >
                                                    Privacy
                                                </a>{' '}
                                                © {new Date().getFullYear()} BCAA
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                                <a
                                    href='https://caa.ca'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='tw-order-1 md:tw-order-2 tw-shrink-0'
                                >
                                    <img
                                        src='https://www.bcaa.com/-/media/bcaa/images/logos/caa-logo.svg?h=35&iar=0&w=53&hash=1DB2EA5D0B9AE16761242DB1DBAEE1C1'
                                        alt='CAA logo'
                                        className='tw-h-8'
                                    />
                                </a>
                            </div>
                        </footer>
                    </div>
                    <div>{this.renderCookie()}</div>
                </div>
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        panels: state.panelsReducer.panels,
        cookieData: state.marketplaceReducer.customFields,
        favIconData: state.marketplaceReducer.favIconData,
        marketplaceName: state.marketplaceReducer.name,
        // parentBlog: state.blogReducer.parentBlog
        marketplaceControlFlags: state.marketplaceReducer.ControlFlags
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadPanels: () => dispatch(panelActions.asyncLoadingPanels()),
        loadMarketplaceInfo: () => dispatch(marketplaceActions.getInfo())
        // getBlogsInfo: () => dispatch(blogActions.getBlogsInfo())
    };
}

const FooterLayout = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(FooterLayoutComponent);

export { FooterLayout, FooterLayoutComponent };

export default {
    FooterLayout,
    FooterLayoutComponent
};
